export default __webpack_public_path__ + "static/media/Youtube.89d61c6e.png";